import { type ReactNode } from "react";
import { useFeatureFlag } from "@/hooks/useFeatureFlags";
import NotFound from "@/pages/NotFound";

// Gates a route behind a DB feature flag. While the flag set is loading we
// render nothing (avoids flashing a 404 before flags resolve); once resolved,
// a disabled flag renders NotFound so the path behaves as if it doesn't exist.
// This is a UX guard — the authoritative gate is server-side on the GraphQL
// resolvers/mutations, added as the puzzle backend lands.
export default function FeatureRoute({
  flag,
  children,
}: {
  flag: string;
  children: ReactNode;
}) {
  const { isEnabled, isLoading } = useFeatureFlag(flag);
  if (isLoading) return null;
  return isEnabled ? <>{children}</> : <NotFound />;
}
